import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router'; 
import { StyleguideSpecimenComponent } from './shared/styleguide-specimen/styleguide-specimen.component';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { CardExpandingComponent } from './card-expanding/card-expanding.component';
import { CardModuleComponent } from './card-module/card-module.component';
import { CardProductComponent } from './card-product/card-product.component';
import { FormTextInputComponent } from './form-text-input/form-text-input.component';
import { FormTextAreaComponent } from './form-text-area/form-text-area.component';
import { FormDropdownComponent } from './form-dropdown/form-dropdown.component';
import { FormCheckboxComponent } from './form-checkbox/form-checkbox.component';
import { AccordionItemComponent } from './accordion-item/accordion-item.component';
import { BrowserModule } from '@angular/platform-browser';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { HybridHref } from '../directives/hybridHref.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TrustHtmlPipe } from '../pipes/trust-html.pipe';

/*
  This module is imported by the generated app-components.module.ts.
  You can use this module to provide shared Angular components that are not
  JSS components, etc to the generated module.

  Don't want code generation? See ./.gitignore for instructions to turn it off.
*/
@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    JssModule,
    FormsModule,
    BrowserModule,
    LazyLoadImageModule,
  ],
  exports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    FormsModule,
    StyleguideSpecimenComponent,
    BrowserModule,
    LazyLoadImageModule,
    AccordionItemComponent,
    CardExpandingComponent,
    CardModuleComponent,
    CardProductComponent,
    FormTextInputComponent,
    FormTextAreaComponent,
    FormDropdownComponent,
    FormCheckboxComponent,
    HybridHref,
    ReactiveFormsModule,
    TrustHtmlPipe,
  ],
  declarations: [
    StyleguideSpecimenComponent,
    AccordionItemComponent,
    CardExpandingComponent,
    CardModuleComponent,
    CardProductComponent,
    FormTextInputComponent,
    FormTextAreaComponent,
    FormDropdownComponent,
    FormCheckboxComponent,
    HybridHref,
    TrustHtmlPipe,
  ],
})
export class AppComponentsSharedModule { }
